(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game/assets/javascripts/animations/show-hide-view.js') >= 0) return;  svs.modules.push('/components/numbergames/game/assets/javascripts/animations/show-hide-view.js');


'use strict';

function animateShowHide(_ref) {
  let {
    el,
    callbackScope,
    onShow,
    onHide
  } = _ref;
  const showTl = gsap.timeline({
    callbackScope,
    onComplete: onShow,
    paused: true
  });
  const hideTl = gsap.timeline({
    callbackScope,
    onComplete: onHide,
    paused: true
  });

  showTl.set(el, {
    scale: 0,
    height: 0,
    opacity: 0
  });
  showTl.to(el, {
    height: 'auto',
    scale: 1,
    duration: 0.4,
    delay: 0.1
  });
  showTl.to(el, {
    opacity: 1,
    duration: 0.4,
    ease: 'power3.in'
  }, '-=.2');
  hideTl.to(el, {
    scale: 0,
    height: 0,
    duration: 0.4,
    delay: 0.1
  });
  hideTl.to(el, {
    opacity: 0,
    duration: 0.2
  }, '<');
  return {
    show: () => showTl.play(0),
    hide: () => hideTl.play(0)
  };
}
svs.numbergames.game.animations.showHideView = {
  animateShowHide
};

 })(window);